module.exports = __webpack_public_path__ + "static/media/slider_st.c7ee6c3b.jpg";